export class CreateUpdateUserDto{
    organizationId: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    notes: string;
    permissions: string[];
}